import React from 'react';
import IconFrame from './Frame';
import PrismPattern from './patterns/Prism';

function PrismFrame(props) {
  return <IconFrame pattern={PrismPattern} isPrism {...props} />;
}

export default PrismFrame;
